<template>
  <el-card class="box-card">
    <div class="tabs">
      <div 
        v-for="item in activeTabList" 
        :key="item.id" 
        @click="changeTab(item)" 
        :class="{ 'active_item': activeTab === item.active }"
        style="padding: 10px 20px;"
      >
        {{ item.name }}
      </div>
    </div>
      <referralList   v-if="activeTab=='referralList'" :clienId="clienId + ''"  :detail="detail"/>
      <gathering v-if="activeTab=='paymentRecords' " :clienId="clienId + ''" :detail ="detail"/>
      <sellRecord v-if="activeTab=='salesRecords' " :clienId="clienId + ''"  :detail="detail"/>
      <redeemList v-if="activeTab=='redeemList' " :clienId="clienId + ''"  :detail="detail"/>
      <refundList v-if="activeTab=='refundList' " :clienId="clienId + ''" :detail ="detail"/>
      <refundGoods v-if="activeTab=='returnList'  " :clienId="clienId + ''" :detail ="detail"/>
      <prestockList   v-if="activeTab=='reservedStock'  " :clienId="clienId + ''" :consignee="detail.customer_name"/>
  </el-card>
</template>

<script>

import gathering from '../order/proceedsList.vue'
import sellRecord from '../order/orderList.vue'
import redeemList from '../order/orderRedeem.vue'
import refundList from '../order/refundList.vue'
import refundGoods from '../order/refundGoods.vue'
import referralList from '../order/referralOrderList.vue'
import prestockList from './prestockList.vue'
export default {
  name: "ClientList",
  props: {
    clienId: {
      type: String,
      default: ""
    },
    detail: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {
      sellRecord,
      redeemList,
      gathering,
      refundList,
      refundGoods,
      prestockList,
      referralList
  },
  mounted () {
    this.activeTab = this.$route.query.activeTab || 'paymentRecords';
  },
  data() {
    return {
      activeTab: 'paymentRecords',
      activeTabList: [
        { name: '收款记录', active: 'paymentRecords', id: 1 },
        { name: '销售记录', active: 'salesRecords', id: 2 },
        { name: '退款列表', active: 'refundList', id: 3 },
        { name: '退货列表', active: 'returnList', id: 4 },
        { name: '预存货', active: 'reservedStock', id: 5 },
        { name: '转诊单', active: 'referralList', id: 6 },
        { name: '核销订单', active: 'redeemList', id: 7 }

      ],
      activeBarStyle: {
        width: '0px',
        transform: 'translateX(0)'
      }
    };
  },
  methods: {
    changeTab(e) {
      this.activeTab = e.active;
    },
  }
};
</script>

<style lang="scss" scoped>
.tabs {
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 600;
  position: relative;
  display: flex;
  
  div {
    cursor: pointer;
    position: relative;
    &::after {
      content: ''; // 必须设置content属性
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%; // 宽度与选项卡标签一致
      height: 3px;
      background-color: #33bea7;
      transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      transform-origin: left;
      transform: scaleX(0); // 默认不显示
    }
  }
  
  .active_item {
    color: #33bea7; // 只保留文字颜色变化
    border-bottom: none; // 移除border-bottom
    /* 显示高亮指示器 */
    &::after {
      transform: scaleX(1); // 完全显示
    }
  }
}
</style>
    